// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".file-upload-list-item{background-color:#fff;box-shadow:0 8px 14.72px 1.28px rgba(101,169,119,.3);padding:.6rem 1rem}.file-upload-list-item+.file-upload-list-item{margin-top:.5rem}.file-upload-list-item__date,.file-upload-list-item__size{margin:auto;color:#acb5be}.file-upload-list-item--undo{background:none;box-shadow:none}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
